import OrgDetails from './OrgDetails';

export default OrgDetails;
